import { useRouteMatch } from 'react-router';
import Footer from '@/components/footer';
import Header from '@/components/header';
import Toolbar from '@/components/toolbar';

const App = ({ Component, ...pageProps }: any) => {
  const match = useRouteMatch();

  return (
    <>
      <Header />
      <Toolbar />
      <Component {...pageProps} />
      <Footer withBanner={match.url === '/'} />
    </>
  );
};

export default App;
